module.exports = __webpack_public_path__ + "img/silver3.7c9b4698.png";